import { Box, Flex, Grid, Heading, ModalCloseButton, Text } from "@chakra-ui/react";
import { AirhelpPlusItalics } from "@airhelp/react";
import { useLanguage } from "contexts/LocalizationContext";
import { useModal } from "contexts/ModalContext";
import { IconLink } from "modules/common/components/IconLink";
import { Stars } from "modules/common/components/Trustpilot/ReviewCard/Stars";
import { renderDynamicComponent } from "modules/storyblok/DynamicComponent";
import type { SbEditableComponentProps } from "types/storyblok";
import { getPageUrl } from "utils/getPageUrl";
import type { AhPlusModalProps } from "./AhPlusModal.d";

export const AhPlusModal = ({
  heading,
  review,
  linkText,
  reviewer,
  ahPlusPricingPlans,
}: SbEditableComponentProps<AhPlusModalProps>) => {
  const { onClose } = useModal();
  const language = useLanguage();

  return (
    <Flex bg="primary.900" minHeight={{ base: "full", xl: "calc(100vh - 32px)" }} flexDir="column" justify="center">
      <ModalCloseButton size="lg" zIndex={2} _hover={{}} _active={{}} />
      <Grid
        justifyContent="center"
        justifyItems="center"
        gap={7}
        templateColumns={{ base: "1fr", lg: "repeat(2, minmax(auto, 400px))", xl: "repeat(3, minmax(auto, 400px))" }}
        templateRows={{ base: "repeat(4, auto)", lg: "repeat(3, auto)", xl: "repeat(3, auto)" }}
        templateAreas={{
          base: "'header' 'ahPlusPricingPlans' 'description'",
          lg: "'header header' 'ahPlusPricingPlans ahPlusPricingPlans' 'description .'",
          xl: "'header ahPlusPricingPlans ahPlusPricingPlans' ' description ahPlusPricingPlans ahPlusPricingPlans'",
        }}
        px={{ base: 4, md: 10 }}
        py={10}
        pt={{ base: 14, md: 20 }}
        pos="relative"
      >
        <Box color="white" gridArea="header">
          <AirhelpPlusItalics w="140px" h="auto" mb={4} display={{ base: "none", xl: "initial" }} />
          <Heading
            color="inherit"
            variant="h2"
            as="h2"
            mx={{ base: 0, md: 10, xl: 0 }}
            textAlign={{ base: "center", xl: "left" }}
          >
            {heading}
          </Heading>
        </Box>
        <Flex gridArea="description" justify="flex-end" flexDir="column" color="white" mt={{ base: 6, xl: 0 }}>
          <Box mb={{ base: 20, xl: 4 }} minH={{ xl: "250px" }}>
            <Stars />
            <Text color="inherit" mt={6} mb={4} fontSize="lg">
              {review}
            </Text>
            <Text color="inherit" fontWeight="bold" fontSize="md">
              {reviewer}
            </Text>
          </Box>
          <IconLink
            onClick={onClose}
            color="white"
            textDecor="underline"
            _visited={{}}
            _hover={{
              textDecor: "underline",
              color: "white",
            }}
            href={getPageUrl(language, "airhelpPlus")}
            text={linkText}
            title={linkText}
            prefetch
          />
        </Flex>
        <Box gridArea="ahPlusPricingPlans">{renderDynamicComponent(ahPlusPricingPlans)}</Box>
      </Grid>
    </Flex>
  );
};
